import type { BadgeVariant } from '../../components/ui/Badge';
import type { KhoaDich } from '../../i18n';
import type { SourceStatus } from './types';

/**
 * Hằng của module `tro-ly-ai` (ADR-0086). Bảng tông nằm ở đây chứ không ở `src/mock/` (CLAUDE.md).
 *
 * Bảng tông của từng nhóm màn nằm ở `constants-<nhóm>.ts` cạnh tệp này và được xuất lại ở cuối tệp — cùng một chỗ để
 * tìm, không phải một tệp nghìn dòng.
 *
 * Chỉ dùng nhóm biến thể **trạng thái** của `Badge` cho trạng thái; nhóm phân loại (`violet`/`teal`/`orange`/`info`)
 * chỉ dùng cho phân loại (loại nguồn, loại khuôn) — cấm dùng lẫn.
 */
export type BienTheTrangThai = Extract<BadgeVariant, 'neutral' | 'primary' | 'success' | 'warning' | 'danger'>;

/**
 * Mã quyền lớp 3, chép nguyên văn `permissions` của `modules/tro-ly-ai/module.yaml`. Màn hỏi bằng
 * `useModulePermissions(QUYEN)`; thiếu quyền thì **ẩn** mục, không hiện mờ (ADR-UI-0005).
 *
 * Bảng ánh xạ từ native: `ASSISTANT_DASHBOARD` → `tongQuanXem`, `ASSISTANT_ASK` → `hoi`, `ASSISTANT_SOURCE.*` →
 * `nguon*`, `ASSISTANT_CHATBOT.*` → `chatbot*`, `ASSISTANT_DATAPERM.*` → `quyenDuLieu*`, `ASSISTANT_TRACE` → `nhatKyXem`.
 */
export const QUYEN = {
  tongQuanXem: 'tro-ly-ai:tong-quan:read',
  hoi: 'tro-ly-ai:hoi:read',
  nguonXem: 'tro-ly-ai:nguon:read',
  nguonTao: 'tro-ly-ai:nguon:create',
  nguonSua: 'tro-ly-ai:nguon:update',
  nguonXoa: 'tro-ly-ai:nguon:delete',
  chatbotXem: 'tro-ly-ai:chatbot:read',
  chatbotTao: 'tro-ly-ai:chatbot:create',
  chatbotSua: 'tro-ly-ai:chatbot:update',
  chatbotXoa: 'tro-ly-ai:chatbot:delete',
  quyenDuLieuXem: 'tro-ly-ai:quyen-du-lieu:read',
  quyenDuLieuSua: 'tro-ly-ai:quyen-du-lieu:update',
  nhatKyXem: 'tro-ly-ai:nhat-ky:read',
} as const;

/** Khoá nhớ dạng lưới/danh sách của từng màn (`useKieuHien`). */
export const KHOA_HIEN = {
  khoDuLieu: 'kho-du-lieu',
  khuon: 'khuon',
  bot: 'tro-chuyen-bot',
} as const;

/**
 * Trạng thái một nguồn. `draft` xám: mới khai, chưa kiểm. `connected` xanh nhấn: nối được, chưa dựng kho xong. `ready`
 * xanh: hỏi được. `error` đỏ.
 */
export const TRANG_THAI_NGUON: Record<SourceStatus, { khoa: KhoaDich; variant: BienTheTrangThai }> = {
  draft: { khoa: 'troLyAi.trangThaiNguon.draft', variant: 'neutral' },
  connected: { khoa: 'troLyAi.trangThaiNguon.connected', variant: 'primary' },
  ready: { khoa: 'troLyAi.trangThaiNguon.ready', variant: 'success' },
  error: { khoa: 'troLyAi.trangThaiNguon.error', variant: 'danger' },
};
